export default () => ({
  listener: null,
  modules: null
})
